

export const frontMatter = {
	title: 'Maximized groups',
	description: 'How to maximize a group to fill the Dockview viewport and restore it programmatically.'
};
export const contentTitle = undefined;
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-core-groups-maximized-groups-mdx-6d7.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [{
  "value": "Options",
  "id": "options",
  "level": 2
}, {
  "value": "Panel API",
  "id": "panel-api",
  "level": 2
}, {
  "value": "See also",
  "id": "see-also",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CodeRunner} = _components;
  if (!CodeRunner) _missingMdxReference("CodeRunner", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Maximizing a group temporarily expands it to fill the entire Dockview viewport, hiding the other groups until you restore it, handy for focusing on a single panel without changing the underlying layout."
    }), "\n", _jsx(CodeRunner, {
      id: "dockview/maximize-group"
    }), "\n", _jsx(_components.h2, {
      id: "options",
      children: "Options"
    }), "\n", _jsx(DocRef, {
      declaration: "DockviewApi",
      methods: ['maximizeGroup', 'hasMaximizedGroup', 'exitMaximizedGroup', 'onDidMaximizedGroupChange']
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const api: DockviewApi;\n\n// maximize a specified group\napi.maximizeGroup(group);\n\n// check whether a specific group is maximized\nconst result: boolean = api.isMaximizedGroup(group);\n\n// if there is any maximized group exit the maximized state\napi.exitMaximizedGroup();\n\n// is there a maximized group\nconst result: boolean = api.hasMaximizedGroup();\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "panel-api",
      children: "Panel API"
    }), "\n", _jsx(DocRef, {
      declaration: "DockviewPanelApi",
      methods: ['maximize', 'isMaximized', 'exitMaximized']
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const api: DockviewPanelApi;\n\n// maximize the group\napi.maximize();\n\n// is this group maximized (if another group is maximized this method will still return false)\nconst result: boolean = api.isMaximized();\n\n// exit only if this group is maximized (if another group is maximized this has no effect)\napi.exitMaximized();\n"
      })
    }), "\n", _jsx(_components.admonition, {
      type: "tip",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "api.<maximize|isMaximized|exitMaximized>"
        }), " is equivalent to ", _jsx(_components.code, {
          children: "api.group.api.<maximize|isMaximized|exitMaximized>"
        }), ".\nThe methods exist on the panel ", _jsx(_components.code, {
          children: "api"
        }), " object for convenience."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "see-also",
      children: "See also"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/core/groups/floatingGroups",
          children: "Floating groups"
        }), ": float a group above the grid"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/core/groups/popoutGroups",
          children: "Popout windows"
        }), ": move a group into a separate browser window"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

